// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"1f48e447","205":"3cbf7e97","529":"0b4a110d","659":"0a70dd25","672":"444c47d4","687":"eb38a860"}[chunkId] + ".chunk.css";
};